import { GettersUtility, ModuleUtilities, MutationsUtility } from '@afrigis/vuex-utilities';

import crudActionsBase from '@/store/crudActionsBase';

import {
  GETTERS,
  MUTATIONS,
  STATE_VARS,
} from '@/store/Constants';

const generate = (endpoint, dataColumnHeaders, additionalState, noActions) => {
  const LOCAL_STATE_VARS = {
    COLUMN_FIELDS: 'ColumnFields',
  };
  const ADDITIONAL_STATE = additionalState || {};
  const initialState = () => ({
    ...ADDITIONAL_STATE,
    [STATE_VARS.DATA]: null,
    [STATE_VARS.IS_LOADING]: false,
    [STATE_VARS.TOTAL_PAGINATED_DATA]: 0,
    [LOCAL_STATE_VARS.COLUMN_FIELDS]: [
      ...dataColumnHeaders,
      (noActions ? null
        : {
          key: 'actions',
          label: 'Actions',
          sortable: false,
        }),
    ],
  });

  const STATE_PROPS_TO_EXPOSE = [
    ...Object.keys(ADDITIONAL_STATE),
    STATE_VARS.DATA,
    STATE_VARS.IS_LOADING,
    STATE_VARS.TOTAL_PAGINATED_DATA,
  ];

  const STATE_PROPS_FOR_GET = [
    ...STATE_PROPS_TO_EXPOSE,
    LOCAL_STATE_VARS.COLUMN_FIELDS,
  ];

  const actions = {
    ...crudActionsBase.scaffold(endpoint),
  };

  const getters = {
    ...GettersUtility.scaffold(initialState(), STATE_PROPS_FOR_GET),
    [GETTERS.FILTERED_DATA]: (stateP) => [...(stateP[STATE_VARS.DATA] ?? [])],
  };

  const mutations = {
    ...MutationsUtility.scaffold(initialState(), STATE_PROPS_TO_EXPOSE),
    [MUTATIONS.RESET]: ModuleUtilities.ResetToInitial(initialState),
  };

  const state = initialState();

  return {
    actions,
    getters,
    mutations,
    state,
  };
};

export default {
  generate,
};
